<mat-dialog-content>
    <div class="mat-dialog-header">
        <h3>Linha de Cuidado - {{careLinePriority.careLinePriorityName}}</h3>
    </div>
    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
        <div class="mat-dialog-content">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <mat-radio-group class="radio-group" aria-label="" formControlName="idCareLinePriorityStatus">
                        <mat-radio-button [value]="statusConfirmed">Confirmar</mat-radio-button>
                        <mat-radio-button [value]="statusDenied">Negar</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Motivo</mat-label>
                        <textarea matInput formControlName="careLinePriorityStatusMotive"
                            maxlength="300" (input)="checkTextareaLimit($event, 'careLinePriorityStatusMotive', 300, 8)">
                        </textarea>
                        <div style="text-align: end; font-size: 12px; color: rgba(0,0,0,.6);">
                            {{careLinePriorityStatusMotiveLength}} / 300 caracteres | {{careLinePriorityStatusMotiveLines}} / 8 linhas
                        </div>
                    </mat-form-field>
                </div>
            </div>
            <div class="footer-panel-modal-list">
                <div class="row">
                    <div class="col-6">
                        <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
                    </div>
                    <div class="col-6">
                        <button mat-flat-button type="submit" color="primary" class=" btn-block">
                            <span>Salvar</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>